const fromCalendarAvailabilityByIdQueryToCalendarAvailability = (data)=>{
    var ref;
    var ref1;
    const perDay = (ref1 = (ref = data === null || data === void 0 ? void 0 : data.availabilityByStoreCodes[0]) === null || ref === void 0 ? void 0 : ref.perDay) !== null && ref1 !== void 0 ? ref1 : {};
    return Object.entries(perDay).reduce((acc, [dateString, { slotsAvailable  }])=>{
        acc[dateString] = slotsAvailable ? slotsAvailable > 0 : false;
        return acc;
    }, {});
};

export { fromCalendarAvailabilityByIdQueryToCalendarAvailability };
//# sourceMappingURL=fromCalendarAvailabilityByIdQueryToCalendarAvailability.js.map
